import MainLayout from './containers/MainLayout'
import albumRoutes from './pages/album/albumRoutes'
import artistRoutes from './pages/artist/artistRoutes'
import playlistRoutes from './pages/playlist/playlistRoutes'
import pisteRoutes from './pages/track/trackRoutes'
import storyRoutes from './pages/story/storyRoutes'
import dynamicListRoutes from './pages/dynamicList/dynamicListRoutes'
import HomePage from "./pages/home/HomePage"

const redirectToMainSite = () => window.location = 'http://www.qobuz.com'
const DefaultRoute = process.env.NODE_ENV === 'development' ? HomePage : redirectToMainSite

export default () => ({
	childRoutes: [
		{
			path: '/',
			component: DefaultRoute
		},
		{
			path: '/',
			component: MainLayout,
			childRoutes: [
				...albumRoutes,
				...artistRoutes,
				...playlistRoutes,
				...pisteRoutes,
				...dynamicListRoutes,
				...storyRoutes // à laisser en dernier car prends tout /xxx/yyy
			]
		},
		{
			path: '*',
			component: DefaultRoute
		}
	]
})



// WEBPACK FOOTER //
// ./src/routes.js